import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Header } from './header/header';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, Header],
  template: `
    <app-header />
    <main class="layout-main">
      <router-outlet />
    </main>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }

    .layout-main {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 1.5rem;
    }
  `,
})
export class Layout {}
